import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticatedGuard } from './authentication/guards/authenticated.guard';
import { AuditorGuard } from './authentication/guards/auditor.guard';

const routes: Routes = [
  {
    path: 'home',
    redirectTo: '/audits/unsubmitted',
    pathMatch: 'full'
  },
  {
    path: 'audits',
    canActivate: [
      AuthenticatedGuard
    ],
    // Note: separated into component-less child route to enforce the order of the guards
    // Angular does NOT provider deterministic sequence of guards, and we always want to
    // check Auth before Role - without combining into a single guard
    children: [
      {
        path: '',
        canActivate: [
          AuditorGuard
        ],
        loadChildren: './audits/audits.module#AuditsModule',
      }
    ]
  },
  {
    path: '',
    redirectTo: '/autologin',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
